module.exports = __webpack_public_path__ + "static/img/staffTaskUnFinish.eb33a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-home/staffTaskUnFinish.png
// module id = rxiD
// module chunks = 1